import {
  http,
} from "./http.js";

async function getCity(resource, id) {
  const response = await http.get(`/${resource}/${id === "0" ? "new" : id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
    region: {
      id: response.data.Region.Id,
      title: response.data.Region.Title,
      isRemoved: response.data.Region.IsRemoved,
    },
    country: {
      id: response.data.Country.Id,
      title: response.data.Country.Title,
      inputLanguage: response.data.Country.InputLanguage,
    },
    district: response.data.District ? {
      id: response.data.District.Id,
      title: response.data.District.Title,
      inputLanguage: response.data.District.InputLanguage,
    } : null,
    isRemoved: response.data.IsRemoved,
    isConfirmed: response.data.IsConfirmed,
  };
}

async function updateCity(resource, id, entity) {
  const response = await http.put(`/${resource}/${id}`, entity);
  return response;
}

async function createCity(resource, entity) {
  const response = await http.post(`/${resource}`, entity);
  return response;
}

async function changeRemovedState(resource, entity) {
  const response = await http.patch(
    `/${resource}/${entity.id}/rpc/change-removed-state`, {
      value: !entity.isRemoved,
    },
  );
  return response;
}

async function deleteCity(resource, id) {
  const response = await http.delete(`${resource}/${id}`);
  return response;
}

async function getCityReference(resource, id) {
  const response = await http.get(`${resource}/referencies/${id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
    country: {
      id: response.data.Country.Id,
      title: response.data.Country.Title,
      inputLanguage: response.data.Country.InputLanguage,
    },
    region: {
      id: response.data.Region.Id,
      title: response.data.Region.Title,
    },
    district: {
      id: response.data.District.Id,
      title: response.data.District.Title,
    },
    isRemoved: response.data.isRemoved,
  };
}

async function fetchAllCities(resource, queryParams) {
  const response = await http.get(`${resource}/referencies?${queryParams}`);
  return response.data.map(i => {
    return {
      text: i.Title,
      value: i.Id,
      country: i.Country ? {
        id: i.Country.Id,
        title: i.Country.Title,
        inputLanguage: i.Country.InputLanguage,
      } : null,
      region: i.Region ? {
        id: i.Region.Id,
        title: i.Region.Title,
      } : null,
      district: i.District ? {
        id: i.District.Id,
        title: i.District.Title,
      } : null,
    };
  });
}

async function getSearchReference(resource, search) {
  const response = await http.get(
    `${resource}/referencies?searchTerm=${search}`,
  );
  return response.data.map(i => {
    return {
      text: i.Title,
      value: i.Id,
      country: {
        id: i.Country.Id,
        title: i.Country.Title,
        inputLanguage: i.Country.InputLanguage,
      },
      region: i.Region ? {
        id: i.Region.Id,
        title: i.Region.Title,
      } : null,
      district: i.District ? {
        id: i.District.Id,
        title: i.District.Title,
      } : null,
    };
  });
}


export {
  getCity,
  updateCity,
  createCity,
  changeRemovedState,
  deleteCity,
  getCityReference,
  fetchAllCities,
  getSearchReference,
};